<template>

    <section class="listing-carousel-container">

        <div class="container">
            <div class="row">
                <div class="col">


                    <div class="project-container">
                        <div class="line-separator"></div>
                        <div class="projects-container">
                            <div class="project-content">
                                <div class="year-items-container">

                                    <div class="project-right">
                                        <div class="listing-card">
                                            <div class="listing-card__date__container">
                                                <div class="listing-card_btn">
                                                    <button class="custom-btn"> test 1 </button>
                                                </div>
                                            </div>

                                            <div class="listing-card__img-container">
                                                <div class="listing-card_img">
                                                    <img src="https://i.picsum.photos/id/128/80/80.jpg?hmac=ytnrNGPRYwdXU1LlfbjUG371JLGb_CggwEMdBYZnS1A" alt="Alternate Text" />
                                                </div>
                                                <div class="listing-card_text">
                                                    <h4 class="listing-card_title">
                                                        test
                                                    </h4>
                                                    <p class="listing-card_subtitle">
                                                        test test  test test  test test  test test
                                                    </p>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div class="project-left">
                                        <div class="listing-card">
                                            <div class="listing-card__date__container">
                                                <div class="listing-card_btn">
                                                    <button class="custom-btn"> test 1 </button>
                                                </div>
                                            </div>

                                            <div class="listing-card__img-container">
                                                <div class="listing-card_img">
                                                    <img src="https://i.picsum.photos/id/128/80/80.jpg?hmac=ytnrNGPRYwdXU1LlfbjUG371JLGb_CggwEMdBYZnS1A" alt="Alternate Text" />
                                                </div>
                                                <div class="listing-card_text">
                                                    <h4 class="listing-card_title">
                                                        test
                                                    </h4>
                                                    <p class="listing-card_subtitle">
                                                        test test  test test  test test  test test
                                                    </p>
                                                </div>
                                            </div>
                              
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="listing-carousel-container__empty-message" >
                        <span class="icon-noResult"></span>
                        <p>لا توجد معلومات متاحة لهذا البحث</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    var instance, currentQueryString;
    var listingId, getSearchParams, dateFrom, dateTo, categoryFilterId, locationFilterId = "";
    var categoryFilterIdSecondaryVal, locationFilterIdSecondaryVal = ""
    var apiListingUrl;
    var postData;
    var currentCLickEvent;
    //var cardIndex = 0;
    var observer;
    var imgs;
    //var scrollValue;
    //import VueAwesomeSwiper from 'vue-awesome-swiper';
    //import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    //import "swiper/dist/css/swiper.min.css";
    import axios from 'axios';
    import { setTimeout } from 'core-js';

    //import Vue from 'vue'
    //import { IconsPlugin } from 'bootstrap-vue';
    //Vue.use(IconsPlugin);
    //import ResponsiveAutoHeight from 'responsive-auto-height';
    //import WOW from 'wow.js';
    //import AOS from 'aos';
    //import 'aos/dist/aos.css';
    export default {
        name: 'listingCarousel',
        //components: {
        //    VueAwesomeSwiper: VueAwesomeSwiper,
        //    Swiper,
        //    SwiperSlide
        //},

        computed: {
            //groupsListing() {
            //    return groupBy(this.listingData, 'date');
            //},
            //groupsTimeline() {
            //    return groupByAddIndex(this.listingData, 'year');
            //}
        },
        data() {
            return {
                //swiperOption: {
                //    slidesPerView: 3,
                //    slidesPerGroup: 3,
                //    spaceBetween: 30,
                //    touchAngle:100,
                //    threshold: 10,
                //    speed: 800,
                //    navigation: {
                //        nextEl: '.swiper-button-next',
                //        prevEl: '.swiper-button-prev'
                //    }
                //},
                listingData: [
                    {

                    }
                ],
                listingDataMoreThanOne: true,
                calendarBarJson: [],
                isAjaxCalled: false,
                //wowInitBefore: false
            }
        },
        mounted() {
            instance = this;


            window.addEventListener("resize", function () {
                setTimeout(function () {

                    if (instance.listingData.length != 0) {
                        matchListingItemsHeight();
                    }
                }, 0);
            });

        },
        created: function () {
            instance = this;

            getSearchParamsFun();
            if (categoryFilterId == "" || categoryFilterId == '""') {
                categoryFilterIdSecondaryVal = "000000000000000000000000";
            } else {
                categoryFilterIdSecondaryVal = categoryFilterId;
            }
            if (locationFilterId == "" || locationFilterId == '""') {
                locationFilterIdSecondaryVal = "000000000000000000000000";
            } else {
                locationFilterIdSecondaryVal = locationFilterId;
            }
            //TODO APICALL HERE
            //console.log(`From ListingCarousel.vue ,ListingID : ${listingId}, dateFrom : ${dateFrom}, dateTo : ${dateTo}, categoryFilterId : ${categoryFilterIdSecondaryVal}, locationFilterId : ${locationFilterIdSecondaryVal}`);
            if (document.location.pathname.includes("listing")) {
                apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=${dateFrom}&todate=${dateTo}&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;
                listingAxiosCall(instance, apiListingUrl);
            } else if (document.location.pathname.includes("detailsItem")) {
                dateFrom = "";
                dateTo = "";
                apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=&todate=&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;

                listingAxiosCall(instance, apiListingUrl);
            }
        },
        props: {
            selectedDate: Object,
            categoriesFilter: Object,
            locationsFilter: Object,
            carouselKey: String
        },

        methods: {
            addToFav: function (id) {
                if (event.target.closest(".listing-card").classList.contains('listing-card--active')) {
                    postData = {
                        id: id,
                        isFav: false
                    }
                } else {
                    postData = {
                        id: id,
                        isFav: true
                    }
                }
                currentCLickEvent = event;
                axios.post("http://localhost:44399/api/content/favourite", postData)
                    .then((response) => {
                        console.log(response);
                        currentCLickEvent.target.closest(".listing-card").classList.toggle("listing-card--active");
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            goToDetails: function (id) {
                //TODO , change this later to be with query string
                currentQueryString = document.location.href.split('?')[1];
                //window.location.href = `/detailsItem/${id}?${currentQueryString}`;


                sessionStorage.setItem(`${window.location.href}`, id);
                //window.location.href = `/detailsItem/${id}?${currentQueryString}`;

                this.$router.push(`/detailsItem/${id}?${currentQueryString}`);
                //& test=${ window.scrollY }
            },
            getListingCard: function () {
                getSearchParamsFun();

                //TODO , change the URL Here to fit Listing Or Details
                if (document.location.pathname.includes("listing")) {
                    apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=${dateFrom}&todate=${dateTo}&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;

                    listingAxiosCall(instance, apiListingUrl);


                } else if (document.location.pathname.includes("detailsItem")) {
                    dateFrom = "";
                    dateTo = "";
                    apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=&todate=&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;

                    listingAxiosCall(instance, apiListingUrl);

                }

            }
        },
        watch: {
            selectedDate: function (newVal, oldVal) { // watch it

                if ((newVal.start != null && newVal.end != null) && (oldVal.start != null && oldVal.end != null)) {
                    if (newVal.start.toDateString() == oldVal.start.toDateString() && newVal.end.toDateString() == oldVal.end.toDateString()) {
                        console.log('Date changed: ', newVal, ' | was: ', oldVal);

                    } else {
                        instance.getListingCard();

                    }
                } else if (newVal.start == null && newVal.end == null || (newVal.start != null && oldVal.start == null)) {
                    instance.getListingCard();
                }
            },
            categoriesFilter: function () { // watch it
                //console.log('CategoryOne: ', newVal, ' | was: ', oldVal);
                instance.getListingCard();
            },
            locationsFilter: function () { // watch it
                //console.log('LocationOne: ', newVal, ' | was: ', oldVal);
                instance.getListingCard();
            }
        },
        beforeRouteLeave(to, from, next) {
            observer = null;
            next();
        }
    }
    function listingAxiosCall(instance) {
        if (document.querySelector(".lds-ring") != null) {
            document.querySelector(".lds-ring").style.visibility = "visible";
        }
        console.log();
        getSearchParamsFun();
        if (categoryFilterId == "" || categoryFilterId == '""') {
            categoryFilterIdSecondaryVal = "000000000000000000000000";
        } else {
            categoryFilterIdSecondaryVal = categoryFilterId;
        }
        if (locationFilterId == "" || locationFilterId == '""') {
            locationFilterIdSecondaryVal = "000000000000000000000000";
        } else {
            locationFilterIdSecondaryVal = locationFilterId;
        }
        //TODO APICALL HERE
        //console.log(`From ListingCarousel.vue ,ListingID : ${listingId}, dateFrom : ${dateFrom}, dateTo : ${dateTo}, categoryFilterId : ${categoryFilterIdSecondaryVal}, locationFilterId : ${locationFilterIdSecondaryVal}`);
        apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=${dateFrom}&todate=${dateTo}&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;
        if (document.location.pathname.includes("listing")) {
            apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=${dateFrom}&todate=${dateTo}&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;
        } else if (document.location.pathname.includes("detailsItem")) {
            dateFrom = "";
            dateTo = "";
            apiListingUrl = `http://localhost:44399/api/content/listing/front?id=${listingId}&fromdate=&todate=&locationid=${locationFilterIdSecondaryVal}&categoryid=${categoryFilterIdSecondaryVal}`;


        }
        //apiListingUrl = `/assets/apisamples/fullListingTest.json`;
        axios({
            method: "GET",
            "url": apiListingUrl
        }).then(response => {
            instance.listingData = [];
            instance.listingData = response.data;
            instance.isAjaxCalled = true;
            if (document.location.pathname.includes("detailsItem")) {
                var currentPageId = document.location.pathname.split('/detailsItem/')[1];

                instance.listingData = instance.listingData.filter(function (obj) {
                    return obj.id != currentPageId;
                });
                if (instance.listingData.length > 12) {
                    instance.listingData = instance.listingData.splice(0, 12);
                }
                if (instance.listingData.length == 0) {
                    document.querySelector('.details__carousel').style.display = 'none';
                }
            }
            (instance.listingData.length == 1 && dateFrom == "" && dateTo == "" && locationFilterIdSecondaryVal == "000000000000000000000000" && categoryFilterIdSecondaryVal == "000000000000000000000000") ?
                instance.listingDataMoreThanOne = false : instance.listingDataMoreThanOne = true;

            instance.$emit("listingDataMoreThanOne", instance.listingDataMoreThanOne);

            //if (instance.wowInitBefore == false) {
            //    setTimeout(function () {
            //        new WOW().init();
            //    }, 100);
            //    instance.wowInitBefore = true;
            //}
            //if (instance.listingData.length != 0) {
            //    matchListingItemsHeight();
            //}

            //AOS.init();

            //if (instance.wowInitBefore == false) {
            //    setTimeout(function () {
            //        AOS.init();
            //    }, 100);
            //    instance.wowInitBefore = true;
            //}


            instance.calendarBarJson = Object.keys(instance.groupsListing);
            imgs = document.querySelectorAll('.listing-card__img-container img');

            imgs.forEach(img => {
                img.src = "";
            });
            setTimeout(function () {
                const options = {
                    rootMargin: "0px 0px -5px 0px"
                }
                if (!window.IntersectionObserver == false) {

                    const lazyLoading = (entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                entry.target.src = entry.target.dataset.src
                                observer.unobserve(entry.target)
                            }
                        })
                    }

                    observer = new IntersectionObserver(lazyLoading, options)

                    imgs = document.querySelectorAll('.listing-card__img-container img');

                    imgs.forEach(img => {
                        observer.observe(img)
                    });

                }


            }, 0);
            //setTimeout(function () {
            document.querySelector(".lds-ring").style.visibility = "hidden";
            //}, 0);


        }, error => {
            console.error(error);
        });
    }
    function getSearchParamsFun() {
        getSearchParams = new URLSearchParams(window.location.search);
        listingId = getSearchParams.get('id');
        categoryFilterId = getSearchParams.get('categoryId');
        locationFilterId = getSearchParams.get('locationId');
        dateFrom = getSearchParams.get('fromDate');
        if (dateFrom == 'undefined' || dateFrom == null) {
            dateFrom = "";
        }
        dateTo = getSearchParams.get('toDate');
        if (dateTo == 'undefined' || dateTo == null) {
            dateTo = "";
        }
    }

    //function groupBy(array, key) {
    //    const result = {};
    //    array.forEach(item => {
    //        if (!result[item[key]]) {
    //            result[item[key]] = [];
    //        }
    //        result[item[key]].push(item);
    //    });
    //    return result;
    //}

    //function groupByAddIndex(array, key) {
    //    cardIndex = 0;
    //    const result = {};
    //    array.forEach(item => {
    //        if (!result[item[key]]) {
    //            result[item[key]] = [];
    //        }
    //        item.itemIndex = cardIndex;
    //        result[item[key]].push(item);
    //        cardIndex++;
    //    });
    //    return result;
    //}
    function matchListingItemsHeight() {

        //setTimeout(function () {
        //    new ResponsiveAutoHeight('.js-auto-height-description');
        //    new ResponsiveAutoHeight('.js-auto-height-tag');
        //    new ResponsiveAutoHeight('.js-auto-height-content');
        //}, 200);
    }

</script>

